import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const KPITracker = () => (
  <Page
    title="KPIs & Analytics"
    intro="KPIs & Analytics gives governance teams live, auto-computed dashboards covering every operational domain - no manual data entry required."
  >
    <Section title="Overview dashboard">
      <Bullets>
        <Bullet>
          Open <DocLink url="/kpi" text="KPIs & Analytics" /> for the executive
          overview: a health score for each domain, headline metrics, and a
          "needs attention" list of every KPI currently missing its target.
        </Bullet>
        <Bullet>
          Choose a date range at the top of the page - it carries across every
          section as you navigate, and it is kept in the page URL
          (?start=&amp;end=), so a bookmarked or shared link opens on the same
          period.
        </Bullet>
        <Bullet>
          Use the PDF button to download a KPI report for the selected date
          range.
        </Bullet>
      </Bullets>
      <Screenshot url="governance/kpi-home.png">
        The KPIs &amp; Analytics overview with per-domain health scores and the
        needs-attention list.
      </Screenshot>
      <Info title="Who can do this?">
        The overview requires the Governance, Manager, or Supervisor team (its
        headline scores also feed the manager dashboard). Opening a section
        dashboard or editing targets requires the Governance team. Site
        administrators always have access. KPIs &amp; Analytics is a tier 2
        feature.
      </Info>
    </Section>
    <Section title="Section dashboards">
      <Bullets>
        <Bullet>
          Click any domain card to open its full dashboard: Clinical Records,
          Patient Safety &amp; Incidents, Medicines Management, Workforce &amp;
          HR, Fleet &amp; Equipment, Clinical Governance, Events, Patient
          Transport, Patient Experience, and Finance.
        </Bullet>
        <Bullet>
          Every KPI is computed live from your operational data - patient
          records, shifts, vehicle checks, audits, journeys, feedback, and
          invoicing.
        </Bullet>
        <Bullet>
          Number tiles with a link drill down when clicked - the whole tile
          opens the records behind the figure, so an unexpected count is one
          click from its underlying data.
        </Bullet>
        <Bullet>
          Each section dashboard has its own PDF button, producing a report of
          just that section's KPIs and charts for the selected date range.
        </Bullet>
        <Bullet>
          The Finance section covers revenue invoiced, estimated event costs,
          event margin, outstanding and overdue balances, quotes expiring
          soon, and an aging debtors breakdown.
        </Bullet>
      </Bullets>
    </Section>
    <Section title="Targets">
      <Bullets>
        <Bullet>
          Each gauge is rated against a target. Defaults are provided, and you
          can set your own per-organisation targets from{' '}
          <DocLink url="/kpi/settings" text="KPI Settings" /> - leave a field
          blank to keep the default. Changes apply to the dashboards and the
          PDF report.
        </Bullet>
      </Bullets>
    </Section>
  </Page>
)

export default KPITracker
